export default "__VITE_ASSET__66K_VJAa__"